/* @flow */
import MessageComposer from './MessageComposer';
import * as React from 'react';
import invariant from 'invariant';
import Chat from 'entities/Chat';

type Props = {
  chat: Chat,
  onMessageSend?: Function,
  className?: string,
};

export class ConversationViewComposer extends React.Component<Props> {
  composer: *;

  focus() {
    if (this.composer) {
      // XXX there should be a better way to enforce this
      invariant(
        this.composer.getDecoratedComponentInstance,
        'composer must be decorated by React-dnd'
      );
      this.composer.getDecoratedComponentInstance().focus();
    }
  }

  render() {
    const { className, chat, onMessageSend, ...rest } = this.props;

    return (
      <MessageComposer
        {...rest}
        chat={chat}
        reference={c => {
          this.composer = c;
        }}
        className={className}
        onMessageSend={onMessageSend}
      />
    );
  }
}

export default ConversationViewComposer;
